import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, TrendingDownIcon, FrownIcon, DollarSignIcon } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: ClockIcon,
    text: 'Tus prospectos se enfrían porque tardas en responder'
  }, {
    icon: TrendingDownIcon,
    text: 'No tienes un sistema de seguimiento y se olvidan de ti'
  }, {
    icon: FrownIcon,
    text: 'Haces todo manualmente y te estás quemando'
  }, {
    icon: DollarSignIcon,
    text: 'Ventas inconsistentes mes tras mes'
  }];
  return <section className="py-24 bg-navy relative border-t border-border/50" data-id="element-94">
      <div className="max-w-5xl mx-auto px-6" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-96">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-97">
            No Necesitas Más Prospectos. <br className="hidden md:block" data-id="element-98" />
            <span className="text-gray-400" data-id="element-99">
              Estás Perdiendo los que Ya Tienes.
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-100">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="card-hover p-6 flex items-start gap-4" data-id="element-101">
              <div className="bg-red-500/10 border border-red-500/20 p-3 rounded-lg shrink-0" data-id="element-102">
                <problem.icon className="w-6 h-6 text-red-400" data-id="element-103" />
              </div>
              <p className="text-gray-300 text-lg font-medium pt-1" data-id="element-104">
                {problem.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}